import { render, staticRenderFns } from "./RemovalModal.vue?vue&type=template&id=616930bb&"
import script from "./RemovalModal.vue?vue&type=script&lang=ts&"
export * from "./RemovalModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports